export const movewareJobRecord = item =>
  (item?.externalRecords || []).find(record => record.recordType === "job");

export const movewareJobId = item => movewareJobRecord(item)?.externalId || "";
